<template>
  <v-app class="flex-fill overflow-hidden">
    <v-navigation-drawer v-model="sideBarOpened" temporary style="display: flex !important; flex-direction: column !important; flex: 1 1 auto;">
      <div class="pa-3">
      <div class="text-center">FAMILIOX</div>
        <div class="text-sm text-center">
          Dein Familien-Manager
        </div>
        <hr/>
        <div class="text-sm text-center">
          <strong>Version:</strong> {{ version }}
          <div class="text-sm text-center" v-if="account !== null">
            <v-icon icon="mdi-account-outline"/> {{ account.vorname }} {{ account.nachname }}
          </div>          
        </div>
        <hr/>
          <div class="text-sm">
              <v-btn block @click="openProfileSettings"><v-icon icon="mdi-cog-outline" class="mr-1"/> Profil / Einstellungen</v-btn>            
              <v-btn color="error" block @click="logout"><v-icon icon="mdi-logout" class="mr-1"/> Abmelden</v-btn>            
          </div>
          <hr/>                 
        <div class="text-sm">
          <strong>Impressum</strong><br/>
          NDG IT-Systeme GmbH<br/>
          Dortansstraße 22a<br/>
          41179 Mönchengladbach<br/><br/>
          <strong>Support</strong><br/>
          <a href="mailto:support@ndg.de">support@ndg.de</a>
        </div>
      </div>
    </v-navigation-drawer>
    <v-app-bar color="primary-darken-1">
      <v-app-bar-nav-icon @click="sideBarOpened = !sideBarOpened" />
      <v-container fluid>
        <v-row align="center">
          <v-col>
            <span class="font-weight-bold">FAMILIOX</span><span class="text-light"> Dein Familien-Manager</span>
          </v-col>
          <v-col cols="auto">
            <kc-clock/>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>          
    <v-main class="ml-3 mr-3 mb-3" style="display: flex !important; flex-direction: column !important; height: 100% !important; overflow: hidden !important; min-height: 0 !important;">
        <f-api ref="api"/>
        <div v-if="isInit" class="flexcol-fill overflow-hidden align-center justify-center">
          <v-progress-linear indeterminate color="primary"/><br/>
          <span class="text-light">FAMILIOX wird für die Verwendung vorbereit...</span>
        </div>
        <div v-if="!isInit && account === null" class="flexcol-fill overflow-hidden">
          <f-login/>
        </div>
        <div v-if="!isInit && account !== null && profileOpened" class="flexcol-fill overflow-hidden">
          <f-profile @close="profileOpened = false"/>
        </div>
        <div v-if="!isInit && authCallbackPayload !== null" class="flexcol-fill overflow-hidden">
          <v-progress-linear indeterminate color="primary"/><br/>
          <span v-if="authCallbackPayload.type == 'google'">Google-Authentifzierung wird abgeschlossen...</span>
          <span v-if="authCallbackPayload.type == 'apple'">Apple-Authentifzierung wird abgeschlossen...</span>
          <span v-if="authCallbackPayload.type == 'microsoft'">Microsoft-Authentifzierung wird abgeschlossen...</span>
        </div> 
        <div v-if="!isInit && account !== null && !profileOpened && authCallbackPayload === null" class="flexcol-fill overflow-hidden">
          <div class="flexrow-fill overflow-hidden mb-3">
            <div class="flexcol-fix bg-surface mt-3" style="width: 31rem;">
              <div class="flexcol-fix bg-primary-darken-1 pl-3 pr-3">
                <h2><v-icon icon="mdi-calendar-outline"/> Termine / Planung</h2>
              </div>
              <div class="flexcol-fill overflow-hidden pa-3">
                <kc-calendar/>
              </div>
            </div>
            <div class="flexcol-fix bg-surface mt-3 ml-3 pa-0" style="width: 31rem;">
              <div class="flexcol-fix bg-primary-darken-1 pl-3 pr-3">
                <h2><v-icon icon="mdi-trash-can-outline"/> Müllentsorgung</h2>
              </div>
              <div class="flexcol-fill overflow-hidden">
                <kc-disposal/>
              </div>
            </div>
            <div class="flexcol-fill mt-3 ml-3 bg-surface">
              <div class="flexcol-fix bg-primary pl-2 pt-4 pr-2">
                <v-tabs v-model="selectedTab" selected-class="font-weight-bold">
                  <v-tab value="wetter" class="mr-3"><v-icon icon="mdi-cloud-outline" class="mr-2"/> Wetter</v-tab>
                  <v-tab value="timer" class="mr-3"><v-icon icon="mdi-clock-outline" class="mr-2"/> Timer</v-tab>
                  <v-tab value="stundenplan" class="mr-3"><v-icon icon="mdi-timetable" class="mr-2"/> Stundenplan</v-tab>
                  <v-tab value="essensplan" class="mr-3"><v-icon icon="mdi-food-outline" class="mr-2"/> Essensplan</v-tab>
                  <v-tab value="radio" class="mr-3"><v-icon icon="mdi-broadcast" class="mr-2"/> Radio</v-tab>
                </v-tabs>            
              </div>
              <div class="flexcol-fill overflow-hidden">
                <v-tabs-window v-model="selectedTab" class="flexcol-fill overflow-hidden">
                  <v-tabs-window-item value="wetter" class="flexcol-fill overflow-hidden">
                    <kc-weather/>
                  </v-tabs-window-item>
                  <v-tabs-window-item value="timer" class="flexcol-fill overflow-hidden">
                    <kc-timers/>
                  </v-tabs-window-item>
                  <v-tabs-window-item value="stundenplan" class="flexcol-fill overflow-hidden">
                    <kc-timetable/>
                  </v-tabs-window-item>                
                  <v-tabs-window-item value="essensplan" class="flexcol-fill overflow-hidden">
                    <kc-menuplan/>
                  </v-tabs-window-item>
                  <v-tabs-window-item value="radio" class="flexcol-fill overflow-hidden">
                    <kc-radio v-model="radioPlaying"/>
                  </v-tabs-window-item>
                </v-tabs-window>
              </div>
            </div>
          </div>
        </div>
        <div class="flexcol-fix bg-primary-darken-1 mb-0 pa-3 text-center">
          <v-container fluid class="pa-0">
            <v-row no-gutters>
              <v-col class="text-sm">
                (C) 2026 <span class="font-weight-bold">FAMILIOX</span> / NDG IT-Systeme GmbH
              </v-col>
            </v-row>
          </v-container>
        </div>
    </v-main>
  </v-app>
</template>
<script>
import fLogin from './components/login.vue';
import kcCalendar from './components/calendar.vue';
import kcWeather from './components/weather.vue';
import kcMenuplan from './components/menuplan.vue';
import kcRadio from './components/radio.vue';
import kcClock from './components/clock.vue';
import kcTimers from './components/timers.vue';
import kcDisposal from './components/disposal.vue';
import kcTimetable from './components/timetable.vue';
import fProfile from './components/profile.vue';
export default {
  name: 'App',
  components: {
    fLogin,
    kcCalendar,
    kcWeather,
    kcMenuplan,
    kcRadio,
    kcClock,
    kcTimers,
    kcDisposal,
    kcTimetable,
    fProfile
  },
  data() {
    return {
      version: '2.0.3',
      isInit: true,
      uhrzeit: null,
      radioPlaying: false,
      sideBarOpened: false,
      selectedTab: 'wetter',
      profileOpened: false,
      authCallbackPayload: null,
      finishingAuthCallback: false
    }
  },
  computed: {
    account() {
      const vm = this;
      return vm.$store.state.account;
    }
  },
  mounted() {
    const vm = this;    
    vm.init(); 
  },
  methods: {   
    init() {
      const vm = this;
      vm.isInit = true;
      vm.startClock();
      vm.restoreAccount();
      vm.checkCallbackActions();   
    },
    restoreAccount() {
      const vm = this;
      let existingAccount = window.localStorage.getItem('account');
      if (existingAccount !== null) {
        vm.$store.state.account = JSON.parse(existingAccount);
        vm.updateAccount();
      } else {
        vm.$store.state.account = null;
        vm.isInit = false;
      }
    },
    updateAccount() {
      const vm = this;
      if (vm.account === null) {
        vm.isInit = false;
        return;
      }
      vm.$refs.api.get('auth/me', result => {
        vm.$store.state.account = result;
        window.localStorage.setItem('account', JSON.stringify(vm.$store.state.account));
        vm.isInit = false;        
      }, () => {
        vm.isInit = false;
      });
    },
    startClock() {
      const vm = this;
      vm.uhrzeit = vm.$dayjs().format('HH:mm');
      vm.user = null;
      window.setInterval(function() {
        vm.uhrzeit = vm.$dayjs().format('HH:mm');
      }, 1000)    
    },
    checkCallbackActions() {
      const vm = this;
      vm.authCallbackPayload = null;
       const params = new URLSearchParams(window.location.search);
       if (params.has('action')) {
         const action = params.get('action');
         // Handle different actions based on the value of 'action'
         switch(action) {
          case 'authCallback':
            vm.isInit = false;
            const type = params.get('type');
             vm.authCallbackPayload = {
              type: type,
              code: params.get('code'),
              state: params.get('state'),
              error: params.get('error')
             };
              vm.finishingAuthCallback = false;              
              vm.$refs.api.post(type + '/callback', vm.authCallbackPayload, () => {
                vm.authCallbackPayload = null;
                vm.finishingAuthCallback = false;
              }, () => {
                vm.finishingAuthCallback = false;
                vm.authCallbackPayload = null;
              });
             break;
          default:
            vm.initServices();
            break;
         }
       }
    },
    openProfileSettings() {
      const vm = this;
      vm.profileOpened = true;
    },
    logout() {
      const vm = this;
      vm.sideBarOpened = false;     
      vm.profileOpened = false; 
      vm.$store.state.account = null;
      window.localStorage.removeItem('account');
    },
    exit() {
      window.close();
    }
  }
}
</script>
<style lang="scss">
  html {
    position: relative;
    min-height: 100%;
  }  
  body {
    margin-bottom: 0rem;    
  }
.header {
  position: absolute;
  top: 0;
  width: 100%;
  height: 4rem;
}
.content {
  display: flex;
  width: 100%;
  margin-top: 0rem;
  margin-bottom: 0rem;
}

</style>
